import { I18nLocale } from '#/i18n/types/I18nLocale';
import { searchGetInternshipsPath } from '#/modules/search/internships/routing/searchGetInternshipsPath';
import { searchGetJobsPath } from '#/modules/search/jobs/routing/searchGetJobsPath';
import { searchGetOrgsPath } from '#/modules/search/orgs/routing/searchGetOrgsPath';

import type { FindAJobDropdownData } from './types/FindAJobDropdownData';

export const findAJobDropdownDataEs: FindAJobDropdownData = {
  search: {
    title: 'Encuentra',
    items: [
      {
        type: 'job',
        title: 'Empleos',
        href: searchGetJobsPath({
          locale: I18nLocale.ES,
          embedSearchWidgetId: null,
        }),
      },
      {
        type: 'internship',
        title: 'Pasantías',
        href: searchGetInternshipsPath({ locale: I18nLocale.ES }),
      },
      {
        type: 'org',
        title: 'Organizaciones',
        href: searchGetOrgsPath({ locale: I18nLocale.ES }),
      },
    ],
  },
  resources: {
    title: 'Recursos',
    items: [
      {
        type: 'career-advice',
        title: 'Desarrollo de carrera',
        description:
          'Herramientas y consejos útiles para construir una carrera profesional con impacto.',
        href: '/es/accion?categories=empleocambiamundo&pq=',
      },
    ],
  },
};
